import Main from '@/views/main.vue'
import Cookies from 'js-cookie'

// 不作为Main组件的子页面展示的页面单独写，如下

export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录'
  },
  component: resolve => {
    require(['@/views/login.vue'], resolve);
    // require(['@/components/vue-cube-datav/cube.vue'], resolve);
  }
};

export const cubeRouter = {
  path: '/cube',
  name: 'cube_zhf',
  meta: {
    title: '智慧大屏'
  },
  component: resolve => {
    require(['@/components/vue-cube-datav/cube.vue'], resolve);
  }
};

export const page404 = {
  path: '*',
  name: 'error-404',
  meta: {
    title: '404-页面不存在'
  },
  component: resolve => {
    require(['@/views/error-page/404.vue'], resolve);
  }
};

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足'
  },
  name: 'error-403',
  component: resolve => {
    require(['@//views/error-page/403.vue'], resolve);
  }
};

export const page500 = {
  path: '/500',
  meta: {
    title: '500-服务端错误'
  },
  name: 'error-500',
  component: resolve => {
    require(['@/views/error-page/500.vue'], resolve);
  }
};

// 锁屏
export const locking = {
  path: '/locking',
  name: 'locking',
  component: resolve => {
    require(['@/components/main-components/lockscreen/components/locking-page.vue'], resolve);
  }
};


// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里(其他页面)
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  redirect: Cookies.get('token') ? '/user-center/home' : '/login',
  component: Main,
  children: [
    {
      path: '/user-center/home', title: '首页', name: 'home_index', component: resolve => {
        require(['@/views/user-center/home/home.vue'], resolve);
      }
    },
    {
      path: '/owns',
      title: '个人中心',
      name: 'owns_index',
      component: resolve => {require(['@/views/own-space/own-space.vue'],resolve)}
    },
    {
      path: '/user-center/message', title: '消息', name: 'message_index', component: resolve => {
        require(['@/views/user-center/message/message.vue'], resolve);
      }
    },
    {
      path: '/user-center/changepwd', name: 'changepsw', title: '修改密码', component: resolve =>{
        require(['@/views/user-center/changepwd/changepsw.vue'],resolve)
      }
    },
    {
      path: '/goodsManage/secondType',
      title: '二级类目',
      name: 'secondType',
      component: resolve => {
        require(['@/views/goodsManage/secondType.vue'], resolve);
      }
    }
    /*,
    {
      path: '/orderManage/dayOrder/refund', title: '退款', name: 'refund', component: resolve => {
        require(['@/views/orderManage/refund.vue'], resolve);
      }
    },
    */
  ]
};


// 注意看过来了,如果你是下拉菜单,>=2级菜单,请勿在name加_index字眼
// 如果是一级,请务必以_index
export const appRouter = [
  /*{
    path: '/home',
    icon: 'md-home',
    name: 'home',
    title: '系统首页',
    component: Main,
    children: [{
      title: '系统首页',
      path: 'home',
      icon: 'social-buffer',
      name: 'home',
      component: resolve => {
        require(['@/views/home/home.vue'], resolve);
      }
    }]
  },*/
  // 设备管理
  {
    checked: true,
    path: '/equipmentManage',
    name: 'equipmentManage',
    title: '设备管理',
    icon: 'ios-analytics-outline',
    //icon: 'icomoon-16',
    component: Main,
    meta: {
      signal: false,
      menuShow: true,
    },
    children: [
      {
        title: '设备品牌管理',
        path: 'deviceBrand',
        name: 'deviceBrand',
        icon: 'ios-megaphone-outline',
        //icon: 'icomoon-35',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/equipmentManage/deviceBrand.vue'], resolve);
        }
      },
      {
        title: '设备类型管理',
        path: 'deviceType',
        name: 'deviceType',
        icon: 'ios-leaf-outline',
        //icon: 'icomoon-15',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/equipmentManage/deviceType.vue'], resolve);
        }
      },
      {
        title: '设备型号管理',
        path: 'deviceModel',
        name: 'deviceModel',
        icon: 'ios-paw-outline',
        //icon: 'icomoon-36',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/equipmentManage/deviceModel.vue'], resolve);
        }
      },
      {
        title: '门控制配置管理',
        path: 'doorCtrl',
        name: 'doorCtrl',
        icon: 'ios-paw-outline',
        //icon: 'icomoon-36',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/equipmentManage/doorCtrl.vue'], resolve);
        }
      },
      {
        title: '门上报配置管理',
        path: 'doorReport',
        name: 'doorReport',
        icon: 'ios-paw-outline',
        //icon: 'icomoon-36',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/equipmentManage/doorReport.vue'], resolve);
        }
      },
      {
        title: '设备列表',
        path: 'deviceList',
        name: 'deviceList',
        icon: 'ios-pizza-outline',
        //icon: 'icomoon-41',
        component: resolve => {
          require(['@/views/equipmentManage/deviceList.vue'], resolve);
        }
      },
      {
        title: '生命周期管理',
        path: 'deviceCarNumber',
        name: 'deviceCarNumber',
        icon: 'ios-planet-outline',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/equipmentManage/deviceCarNumber.vue'], resolve);
        }
      }
      /*
      {
        title: '盒子列表',
        path: 'deviceBoxList',
        name: 'deviceBoxList',
        icon: 'ios-pulse-outline',
        component: resolve => {
          require(['@/views/equipmentManage/deviceBoxList.vue'], resolve);
        }
      }*/]
  },
  // 设备固件管理
  {
    checked: true,
    path: '/fwManage',
    name: 'fwManage',
    title: '设备固件管理',
    icon: 'ios-stats-outline',
    //icon: 'icomoon-16',
    component: Main,
    meta: {
      signal: false,
      menuShow: true,
    },
    children: [
      {
        title: '设备固件列表',
        path: 'deviceOta',
        name: 'deviceOta',
        icon: 'ios-megaphone-outline',
        //icon: 'icomoon-35',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/fwManage/deviceOta.vue'], resolve);
        }
      },
      {
        title: '设备升级管理',
        path: 'deviceUpdate',
        name: 'deviceUpdate',
        icon: 'ios-leaf-outline',
        //icon: 'icomoon-15',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/fwManage/deviceUpdate.vue'], resolve);
        }
      }
      ]
  },
  // 规则管理
  {
    checked: true,
    path: '/ruleManage',
    name: 'ruleManage',
    title: '规则引擎管理',
    icon: 'ios-options-outline',
    //icon: 'icomoon-16',
    component: Main,
    meta: {
      signal: false,
      menuShow: true,
    },
    children: [
      {
        title: '手动规则管理',
        path: 'handleRuleManage',
        name: 'handleRuleManage',
        icon: 'ios-hand-outline',
        //icon: 'icomoon-35',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/ruleManage/handleRuleManage.vue'], resolve);
        }
      },
      {
        title: '事件规则管理',
        path: 'eventRuleManage',
        name: 'eventRuleManage',
        icon: 'ios-link-outline',
        //icon: 'icomoon-15',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/ruleManage/eventRuleManage.vue'], resolve);
        }
      },
      {
        title: '定时规则管理',
        path: 'timingRuleManage',
        name: 'timingRuleManage',
        icon: 'ios-stopwatch-outline',
        //icon: 'icomoon-15',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/ruleManage/timingRuleManage.vue'], resolve);
        }
      }
      ]
  },
  // 厂商管理
  {
    checked: true,
    path: '/factoryManage',
    name: 'factoryManage',
    title: '厂商管理',
    icon: 'ios-bug-outline',
    //icon: 'icomoon-32',
    meta: {
      signal: false,
      menuShow: true
    },
    component: Main,
    children: [
      {
        title: '厂商级别管理',
        path: 'factoryLevel',
        name: 'factoryLevel',
        icon: 'ios-leaf-outline',
        //icon: 'icomoon-25',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/factoryManage/factoryLevel.vue'], resolve);
        }
      },
      {
        title: '厂商列表管理',
        path: 'factory',
        name: 'factoryList',
        icon: 'ios-megaphone-outline',
        //icon: 'icomoon-27',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/factoryManage/factory.vue'], resolve);
        }
      },
      {
        title: '厂商角色管理',
        path: 'factoryRole',
        name: 'factoryRole',
        icon: 'ios-paw-outline',
        //icon: 'icomoon-18',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/factoryManage/factoryRole.vue'], resolve);
        }
      },
      {
        title: '厂商员工管理',
        path: 'factoryMem',
        name: 'factoryMem',
        icon: 'ios-pizza-outline',
        //icon: 'icomoon-10',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/factoryManage/factoryMem.vue'], resolve);
        }
      },
      {
        title: '厂商APP管理',
        path: 'factoryApp',
        name: 'factoryApp',
        icon: 'ios-ribbon-outline',
        //icon: 'icomoon-10',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/factoryManage/factoryApp.vue'], resolve);
        }
      },
      {
        title: '厂商门类型管理',
        path: 'factoryDoor',
        name: 'factoryDoor',
        icon: 'ios-ribbon-outline',
        //icon: 'icomoon-10',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/factoryManage/factoryDoor.vue'], resolve);
        }
      },
      {
        title: '厂商广告管理',
        path: 'Advertisement',
        name: 'Advertisement',
        icon: 'md-contrast',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/factoryManage/Advertisement.vue'], resolve);
        }
      }
      ]
  },
  // 用户管理
  {
    checked: true,
    path: '/userManage',
    name: 'userManage',
    title: '用户管理',
    icon: 'ios-bowtie-outline',
    //icon: 'icomoon-4',
    meta: {
      signal: false,
      menuShow: true
    },
    component: Main,
    children: [
      {
        title: '用户列表',
        path: 'weChatUserList',
        name: 'weChatUserList',
        icon: 'ios-leaf-outline',
        //icon: 'icomoon-41',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/userManage/weChatUserList.vue'], resolve);
        }
      },
      {
        title: '区域列表',
        path: 'userAreaList',
        name: 'userAreaList',
        icon: 'ios-megaphone-outline',
        //icon: 'icomoon-9',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/userManage/userAreaList.vue'], resolve);
        }
      }
    ]
  },
  // 品牌商管理
  {
    path: '/dealerManager',
    name: 'dealerManager',
    icon: 'ios-rose-outline',
    title: '品牌商管理',
    meta: {
      signal: false,
      menuShow: true
    },
    component: Main,
    children: [
      {
        path: 'dealerList',
        name: 'dealerList',
        icon: 'ios-menu-outline',
        title: '品牌商列表',
        meta: {
          signal: false,
          menuShow: true
        },
        component: () => import('@/views/dealerManager/dealerList.vue')
      },
      {
        path: 'dealerAccount',
        name: 'dealerAccount',
        icon: 'ios-paper-outline',
        title: '品牌商账单',
        meta: {
          signal: false,
          menuShow: true
        },
        component: () => import('@/views/dealerManager/dealerAccount.vue')
      },
      {
        path: 'dealerWithdrawal',
        name: 'dealerWithdrawal',
        icon: 'ios-share-outline',
        title: '品牌商提现',
        meta: {
          signal: false,
          menuShow: true
        },
        component: () => import('@/views/dealerManager/dealerWithdrawal.vue')
      },
      {
        path: 'dealerStock',
        name: 'dealerStock',
        icon: 'ios-filing-outline',
        title: '品牌商库存',
        meta: {
          signal: false,
          menuShow: true
        },
        component: () => import('@/views/dealerManager/dealerStock.vue')
      }
    ]
  },
  //商品管理
  {
    path: '/goodsManage',
    name: 'goodsManage',
    title: '商品管理',
    icon: 'ios-basket-outline',
    meta: {
      signal: false,
      menuShow: true
    },
    component: Main,
    children: [
      {
        title: '商品类目管理',
        path: 'goodsType',
        name: 'goodsType',
        icon: 'ios-card-outline',
        meta: {
          menuShow: true
        },
        component: resolve => {
          require(['@/views/goodsManage/goodsType.vue'], resolve);
        }
      },
      {
        path: 'platformGoods',
        name: 'platformGoods',
        icon: 'ios-apps-outline',
        title: '平台商品列表',
        meta: {
          signal: false,
          menuShow: true
        },
        component: () => import('@/views/goodsManage/platformGoods.vue')
      },
      {
        path: 'dealerGoods',
        name: 'dealerGoods',
        icon: 'ios-ribbon-outline',
        title: '品牌商商品列表',
        meta: {
          signal: false,
          menuShow: true
        },
        component: () => import('@/views/goodsManage/dealerGoods.vue')
      },
      {
        title: '厂商商品列表',
        path: 'goodsList',
        name: 'goodsList',
        icon: 'ios-leaf-outline',
        meta: {
          menuShow: true
        },
        component: resolve => {
          require(['@/views/goodsManage/goodsList.vue'], resolve);
        }
      },
      {
        title: '运营报表',
        path: 'listOut',
        name: 'listOut',
        icon: 'ios-browsers-outline',
        meta: {
          menuShow: true
        },
        component: resolve => {
          require(['@/views/goodsManage/listOut.vue'], resolve);
        }
      }
    ]
  },
  // 订单管理
  {
    path: '/orderListManage',
    name: 'orderListManage',
    title: '订单管理',
    icon: 'ios-cart-outline',
    meta: {
      signal: false,
      menuShow: true
    },
    component: Main,
    children: [
      {
        title: '今日订单',
        path: 'dealerOrder',
        name: 'dealerOrder',
        icon: 'ios-paper-outline',
        meta: {
          menuShow: true
        },
        component: resolve => {
          require(['@/views/orderListManage/dealerOrder.vue'], resolve);
        }
      },
      {
        title: '历史订单',
        path: 'dealerHisOrder',
        name: 'dealerHisOrder',
        icon: 'ios-paper-outline',
        meta: {
          menuShow: true
        },
        component: resolve => {
          require(['@/views/orderListManage/dealerHisOrder.vue'], resolve);
        }
      },
      {
        title: '当日退款订单',
        path: 'dayRefundOrder',
        name: 'dayRefundOrder',
        icon: 'ios-undo-outline',
        meta: {
          menuShow: true
        },
        component: resolve => {
          require(['@/views/orderListManage/dayRefundOrder.vue'], resolve);
        }
      },
      {
        title: '历史退款订单',
        path: 'refundOrdersForHis',
        name: 'refundOrdersForHis',
        icon: 'ios-undo-outline',
        meta: {
          menuShow: true
        },
        component: resolve => {
          require(['@/views/orderListManage/refundOrdersForHis.vue'], resolve);
        }
      }
    ]
  },
  // 日志记录
  {
    checked: true,
    path: '/dailyRecord',
    name: 'dailyRecord',
    title: '日志记录',
    icon: 'ios-chatbubbles-outline',
    //icon: 'icomoon-2',
    meta: {
      signal: false,
      menuShow: true
    },
    component: Main,
    children: [
      {
        title: '设备上报信息',
        path: 'deviceReportInfo',
        name: 'deviceReportInfo',
        icon: 'ios-leaf-outline',
        //icon: 'icomoon-11',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/dailyRecord/deviceReportInfo.vue'], resolve);
        }
      },
      {
        title: '用户操作日志',
        path: 'userDailyInfo',
        name: 'userDailyInfo',
        icon: 'ios-megaphone-outline',
        //icon: 'icomoon-33',
        meta: {
          menuShow: true,
        },
        component: resolve => {
          require(['@/views/dailyRecord/userDailyInfo.vue'], resolve);
        }
      }  
    ]
  },
  /*
  // 商家管理
  {
    path: '/businessManage',
    name: 'businessManage',
    title: '商家管理',
    icon: 'ios-bug-outline',
    component: Main,
    children: [
      {
        title: '商家列表',
        path: 'businessList',
        name: 'businessList',
        icon: 'ios-rainy-outline',
        component: resolve => {
          require(['@/views/businessManage/businessList.vue'], resolve);
        }
      },
      {
        title: '商家微信',
        path: 'businessWeChat',
        name: 'businessWeChat',
        icon: 'ios-restaurant-outline',
        component: resolve => {
          require(['@/views/businessManage/businessWeChat.vue'], resolve);
        }
      },
      {
        title: '商家充值',
        path: 'businessRecharge',
        name: 'businessRecharge',
        icon: 'ios-ribbon-outline',
        component: resolve => {
          require(['@/views/businessManage/businessRecharge.vue'], resolve);
        }
      },
      {
        title: '商家账单',
        path: 'businessBill',
        name: 'businessBill',
        icon: 'ios-rose-outline',
        component: resolve => {
          require(['@/views/businessManage/businessBill.vue'], resolve);
        }
      },
      {
        title: '商家结算',
        path: 'businessAccount',
        name: 'businessAccount',
        icon: 'ios-settings-outline',
        component: resolve => {
          require(['@/views/businessManage/businessAccount.vue'], resolve);
        }
      }]
  },
  // 合伙人管理
  {
    path: '/partnerManage',
    name: 'partnerManage',
    title: '合伙人管理',
    icon: 'ios-chatbubbles-outline',
    component: Main,
    children: [
      {
        title: '合伙类型',
        path: 'partnerType',
        name: 'partnerType',
        icon: 'ios-speedometer-outline',
        component: resolve => {
          require(['@/views/partnerManage/partnerType.vue'], resolve);
        }
      },
      {
        title: '意向合伙',
        path: 'intentionPartner',
        name: 'intentionPartner',
        icon: 'ios-stopwatch-outline',
        component: resolve => {
          require(['@/views/partnerManage/intentionPartner.vue'], resolve);
        }
      },
      {
        title: '合作合伙',
        path: 'teamPartner',
        name: 'teamPartner',
        icon: 'ios-tennisball-outline',
        component: resolve => {
          require(['@/views/partnerManage/teamPartner.vue'], resolve);
        }
      },
      {
        title: '结算管理',
        path: 'accountManage',
        name: 'accountManage',
        icon: 'ios-train-outline',
        component: resolve => {
          require(['@/views/partnerManage/accountManage.vue'], resolve);
        }
      }]
  },
  // 订单管理
  {
    path: '/orderManage',
    name: 'orderManage',
    title: '订单管理',
    icon: 'ios-stats-outline',
    component: Main,
    children: [
      {
        title: '当日消费订单',
        path: 'dayOrders',
        name: 'dayOrders',
        icon: 'ios-umbrella-outline',
        component: resolve => {
          require(['@/views/orderManage/dayOrders.vue'], resolve);
        }
      },
      {
        title: '当日退款订单',
        path: 'dayRefundOrder',
        name: 'dayRefundOrder',
        icon: 'logo-reddit',
        component: resolve => {
          require(['@/views/orderManage/dayRefundOrder.vue'], resolve);
        }
      },
      {
        title: '当日充值订单',
        path: 'dayRechargeOrders',
        name: 'dayRechargeOrders',
        icon: 'ios-refresh-circle-outline',
        component: resolve => {
          require(['@/views/orderManage/dayRechargeOrders.vue'], resolve);
        }
      },
      {
        title: '历史消费订单',
        path: 'dayOrdersForHis',
        name: 'dayOrdersForHis',
        icon: 'ios-pulse-outline',
        component: resolve => {
          require(['@/views/orderManage/dayOrdersForHis.vue'], resolve);
        }
      },
      {
        title: '历史退款订单',
        path: 'refundOrdersForHis',
        name: 'refundOrdersForHis',
        icon: 'ios-school-outline',
        component: resolve => {
          require(['@/views/orderManage/refundOrdersForHis.vue'], resolve);
        }
      },
      {
        title: '历史充值订单',
        path: 'rechargeOrdersForHis',
        name: 'rechargeOrdersForHis',
        icon: 'ios-send-outline',
        component: resolve => {
          require(['@/views/orderManage/rechargeOrdersForHis.vue'], resolve);
        }
      }]
  },
  // 工单管理
  {
    path: '/workOrderManage',
    name: 'workOrderManage',
    title: '工单管理',
    icon: 'ios-snow-outline',
    component: Main,
    children: [
      {
        title: '工单列表',
        path: 'workOrderList',
        name: 'workOrderList',
        component: resolve => {
          require(['@/views/workOrderManage/workOrderList.vue'], resolve);
        }
      },]
  },
  // 财务报表
  {
    path: '/finanStatement',
    name: 'finanStatement',
    title: '财务报表',
    icon: 'ios-ionitron-outline',
    component: Main,
    children: [
      {
        title: '合伙人月报',
        path: 'partnerMReport',
        name: 'partnerMReport',
        component: resolve => {
          require(['@/views/finanStatement/partnerMReport.vue'], resolve);
        }
      },]
  },
  // 控制台
  
  {
    path: '/terminal',
    name: 'terminal',
    title: '控制台',
    icon: 'ios-settings-outline',
    component: Main,
    children: [
      //
      {
        title: '车辆分布(测试)',
        path: 'deviceDistribution',
        name: 'deviceDistribution',
        component: resolve => {
          require(['@/views/terminal/deviceDistribution.vue'], resolve);
        }
      },
      {
        title: '图表(测试)',
        path: 'echarts',
        name: 'echarts',
        component: resolve => {
          require(['@/views/terminal/echarts.vue'], resolve);
        }
      },
      //
    ]
  },
  */
  /*{
    path: '/systemManage',
    name: 'systemManage',
    title: '系统管理',
    icon: 'ios-rose-outline',
    component: Main,
    children: [
      {
        title: '人员管理',
        path: 'userManage',
        name: 'userManage',
        component: resolve => {
          require(['@/views/systemManage/userManage.vue'], resolve);
        }
      },
      {
        title: '角色管理',
        path: 'roleManage',
        name: 'roleManage',
        component: resolve => {
          require(['@/views/systemManage/roleManage.vue'], resolve);
        }
      },
      {
        title: '资源管理',
        path: 'resoManage',
        name: 'resoManage',
        component: resolve => {
          require(['@/views/systemManage/resoManage.vue'], resolve);
        }
      }]
  },*/
  // 控制台
  {
    checked: true,
    path: '/platPersonManage',
    name: 'platPersonManage',
    title: '平台人员管理',
    icon: 'ios-settings-outline',
    //icon: 'icomoon-39',
    meta: {
      signal: false,
      menuShow: true
    },
    component: Main,
    children: [
      {
        checked: true,
        title: '角色管理',
        path: 'permissionManage',
        name: 'permissionManage',
        icon: 'ios-leaf-outline',
        //icon: 'icomoon-10',
        meta: {
          menuShow: true
        },
        component: resolve => {
          require(['@/views/platPersonManage/permissionManage.vue'], resolve);
        }
      },
      {
        checked: true,
        title: '人员管理',
        path: 'PersonManage',
        name: 'PersonManage',
        icon: 'ios-megaphone-outline',
        //icon: 'icomoon-18',
        meta: {
          menuShow: true
        },
        component: resolve => {
          require(['@/views/platPersonManage/PersonManage.vue'], resolve);
        }
      },
    ]
  },
];

/*
export const roleList = JSON.parse(JSON.stringify(appRouter)).map(val => {
  val.expand = true;
  if (val.children && val.children.length) {
    val.children = val.children.filter((item => !item.meta.hideInMenu))
    val.children.map(item => {
      if (item.children && item.children.length) {
        item.expand = true;
        item.children = item.children.filter(child => child.meta.hideInMenu != true)
      }
    })
  }
  return val;
});
*/

// 导出routes
export const routers = [
  loginRouter,
  cubeRouter,
  otherRouter,
  ...appRouter,
  locking,
  page404,
  page403,
  page500,
];



// WEBPACK FOOTER //
// ./src/router/router.js